// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"featuredPromoCard__gradient-bg5__yhvwI","featuredPromoCard":"featuredPromoCard__featuredPromoCard__HrtjX"};